import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import FloatingWhatsApp from "@/components/site/FloatingWhatsApp";
import CookieBanner from "@/components/site/CookieBanner";
import Home from "@/pages/Home";
import CardPayments from "@/pages/CardPayments";
import POSSystems from "@/pages/POSSystems";
import WebsiteDesign from "@/pages/WebsiteDesign";
import AppDesign from "@/pages/AppDesign";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import GetStarted from "@/pages/GetStarted";
import Privacy from "@/pages/Privacy";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/card-payments" element={<CardPayments />} />
            <Route path="/pos-systems" element={<POSSystems />} />
            <Route path="/website-design" element={<WebsiteDesign />} />
            <Route path="/app-design" element={<AppDesign />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/get-started" element={<GetStarted />} />
            <Route path="/privacy" element={<Privacy />} />
          </Routes>
        </main>
        <Footer />
        <FloatingWhatsApp />
        <CookieBanner />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
